export default "__VITE_PUBLIC_ASSET__a643ad5a__"